// register component(s) with react habitat
import codeSplit from '@/higher-order-components/codeSplit';

export default {
	EstateFilterReduced: codeSplit( {
		loadComponent: () =>
			import(
				/* webpackChunkName: "EstateFilterReduced" */
				'./index'
			),
	} ),
};
